import Mutations from '../../odata/mutations';

export default { ...new Mutations('attachment'), ...new Mutations('attachments') };
